var React = require('react');

function Sliders (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 6a3.001 3.001 0 002.83-2H16V2h-3.17a3.001 3.001 0 00-5.66 0H0v2h7.17A3.001 3.001 0 0010 6zm-1.17 4H16v2H8.83a3.001 3.001 0 01-5.66 0H0v-2h3.17a3.001 3.001 0 015.66 0z","fill":"#919DAF"}));
}

Sliders.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"};

module.exports = Sliders;

Sliders.default = Sliders;
